import { css } from 'lit';

export const styles = css`
  .data-table-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: var(--sl-color-neutral-0);
    overflow: hidden;
  }

  /* Header */
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: var(--sl-color-neutral-0);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 1rem;
    position: sticky;
    top: 0;
    z-index: 5;
  }

  .title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .title-group {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .filters {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
  }

  /* Table */
  .table-container {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }

  table.data-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: auto;
    background: var(--sl-color-neutral-0);
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: var(--sl-color-neutral-0);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    text-align: left;
    font-weight: 600;
    padding: 0.75rem;
    white-space: nowrap;
    user-select: none;
    box-shadow: 0 1px 0 0 var(--sl-color-neutral-200);
  }

  th[role="button"] {
    cursor: pointer;
  }

  th[role="button"]:hover {
    background: var(--sl-color-neutral-50);
  }

  th[draggable="true"] {
    cursor: grab;
  }

  th[draggable="true"]:active {
    cursor: grabbing;
  }

  th.drag-over {
    background: var(--sl-color-primary-50);
    border-left: 3px solid var(--sl-color-primary-600);
  }

  .column-header {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  tbody tr {
    cursor: pointer;
  }

  tbody tr:hover {
    background: var(--sl-color-neutral-50);
  }

  tbody tr[tabindex="0"] {
    outline: none;
  }

  tbody tr[tabindex="0"]:focus {
    background: var(--sl-color-neutral-50);
    box-shadow: inset 0 0 0 2px var(--sl-color-primary-600);
  }

  tbody td {
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 0.75rem;
    vertical-align: top;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 1px;
  }


  /* Empty & loading states */
  .empty-state,
  .loading-state {
    text-align: center;
    padding: 2rem;
  }

  .empty-state .empty {
    color: var(--sl-color-neutral-500);
  }

  .empty sl-icon {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    display: block;
  }

  .loading-state {
    color: var(--sl-color-neutral-500);
  }

  /* Pagination */
  .pagination-container {
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem 0.75rem;
    border-top: 1px solid var(--sl-color-neutral-200);
    background: var(--sl-color-neutral-0);
  }

  .pagination-controls {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    font-size: 0.875rem;
    color: var(--sl-color-neutral-600);
  }

  .pagination-text {
    white-space: nowrap;
  }

  .rows-per-page {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    white-space: nowrap;
  }

  .rows-per-page sl-select {
    min-width: 70px;
  }

  .pagination-nav {
    display: flex;
    gap: 0.25rem;
  }

  .pagination-nav sl-button {
    min-width: 32px;
  }

  /* Created column specific styles (from assets) */
  .created-col {
    width: auto;
    min-width: 140px;
    white-space: nowrap;
  }

  tbody td.created-cell {
    overflow: visible;
    text-overflow: clip;
    white-space: nowrap;
  }

  /* Name cell specific styles (from assets) */
  .name-cell .name {
    display: flex;
    gap: 0.5rem;
    align-items: baseline;
  }

  .name .primary {
    font-weight: 600;
  }

  .name .secondary {
    color: var(--sl-color-neutral-500);
    font-size: 0.85rem;
  }

  .row-caret {
    color: var(--sl-color-neutral-400);
    font-size: 0.875rem;
  }

  /* Status and location cells */
  .status-cell,
  .location-cell {
    text-align: center;
  }

  /* Mobile responsive */
  @media (max-width: 768px) {
    .header {
      flex-direction: column;
      align-items: stretch;
      gap: 1rem;
    }

    .title-group {
      justify-content: space-between;
    }

    .filters {
      gap: 0.5rem;
    }

    .filters > * {
      flex: 1;
      min-width: 0;
    }

    tbody td {
      padding: 0.5rem;
      font-size: 0.875rem;
    }


    .pagination-container {
      justify-content: center;
    }

    .pagination-controls {
      flex-direction: column;
      gap: 0.75rem;
      align-items: center;
    }
  }
`;
